// GENERATED FILE - do not edit.
// Emitted by tools/generate-wire-schemas.mjs from
// Server/src/Shared/Server/Resources/openapi.json (the spec lockfile).
// Regenerate with: npm run generate:wire
//
// Base wire shape for the server "ChatWorkflowSummary" component. The corresponding
// *.schema.ts is the facade that names it (and hosts any future refinement);
// see design/wiki/wire-schemas.md.
import { z } from "zod";
import { ChatWorkflowStatus } from "./chat-workflow-status.enum.gen";
import { ChatWorkflowBuildStatus } from "./chat-workflow-build-status.enum.gen";

export const ChatWorkflowSummaryGenShape = z.strictObject({
  id: z.string(),
  workflowId: z.string(),
  name: z.string(),
  description: z.string().optional(),
  versionLabel: z.string().optional(),
  engineVersion: z.number(),
  status: z.enum(ChatWorkflowStatus),
  buildStatus: z.enum(ChatWorkflowBuildStatus),
  promoted: z.boolean(),
  archived: z.boolean(),
  createdAt: z.string(),
  updatedAt: z.string(),
  publishedAt: z.string().optional(),
});
